/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border-filde[_ngcontent-%COMP%]{color:grey;text-align:left;padding-bottom:10px;padding-top:20px}.form-group[_ngcontent-%COMP%]{text-align:left}.form-group[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{padding-left:5px}.form-group[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{padding:20px;border:1px solid #bbb}"];
export { styles as styles };
